import { Play } from "lucide-react";

const PLATFORMS = [
  { label: "Spotify", id: "spotify" },
  { label: "Apple Podcasts", id: "apple" },
  { label: "YouTube", id: "youtube" },
  { label: "Instagram", id: "instagram" },
];

export const Footer = ({ site }) => {
  const activePlatforms = PLATFORMS.filter((platform) => site?.platforms?.[platform.id]);

  return (
    <footer data-testid="site-footer" className="border-t border-bone/10 bg-coal">
      <div className="mx-auto max-w-6xl px-6 py-20">
        <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-display text-5xl font-black tracking-tight text-bone sm:text-6xl">
              REEL <span className="italic text-ruby">vs</span> REAL
            </p>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-smoke">
              How film shapes the way we love
            </p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
              Hosted by Mel Masry · Nile FM
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <a
              href="#latest"
              data-testid="footer-listen-cta"
              className="flex w-fit items-center gap-3 bg-ruby px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-ruby-bright"
            >
              <Play size={14} /> Listen now
            </a>
            {activePlatforms.length > 0 && (
              <div className="flex gap-6">
                {activePlatforms.map((platform) => (
                  <a
                    key={platform.id}
                    href={site.platforms[platform.id]}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-platform-${platform.id}`}
                    className="font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors duration-300 hover:text-ruby"
                  >
                    {platform.label}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-bone/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © {new Date().getFullYear()} Reel vs Real. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            Made for late nights.
          </p>
          <a
            href="/studio"
            data-testid="footer-studio-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-700 transition-colors duration-300 hover:text-smoke"
          >
            Studio
          </a>
          <a
            href="/privacy"
            data-testid="footer-privacy-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-700 transition-colors duration-300 hover:text-smoke"
          >
            Privacy
          </a>
          <a
            href="/terms"
            data-testid="footer-terms-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-700 transition-colors duration-300 hover:text-smoke"
          >
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
};
